import { Navigate, Route, Routes } from 'react-router';
import './App.css';

import RouterDebugger from '@/components/DEBUG/RouterDebugger/RouterDebugger';

import ErrorBoundary from '@/wrappers/ErrorBoundary';
import ScrollToTop from '@/components/ScrollTop/ScrollTop';

import Layout from '@/components/Layout';

import SendGiftPage from './pages/SendGift';
import PersonaliseOccasionPage from '@/pages/PersonaliseOccasion';
import GiftDetailsPage from '@/pages/GiftDetails';
import PaymentHandoffPage from '@/pages/Payment';
import PaymentCallbackPage from '@/pages/PaymentCallback';
import ConfirmationPage from '@/pages/Confirmation';
import PaymentFailurePage from '@/pages/PaymentFailure/PaymentFailure';
import AboutUsPage from '@/pages/AboutUs';
import SettingsPage from '@/pages/Settings/settings';
import NotFoundPage from '@/pages/error-pages/NotFound';
import ErrorPage from '@/pages/error-pages/Error';


function App() {
  return (
    <>
      <ScrollToTop />
      <RouterDebugger />
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<SendGiftPage />} />
          <Route
            path='personalise-occasion'
            element={<ErrorBoundary><PersonaliseOccasionPage /></ErrorBoundary>}
          />

          <Route path='gift-details' element={<ErrorBoundary><GiftDetailsPage /></ErrorBoundary>} />

          <Route path='payment' element={<ErrorBoundary><PaymentHandoffPage /></ErrorBoundary>} />
          {/* The payment-method picker was removed in V2 (GIFTWEB-26): the
              message step hands straight to the bank. Kept as a redirect so
              history entries and bookmarks do not land on the 404. */}
          <Route path='payment-method' element={<Navigate to='/payment' replace />} />
          <Route path='about-us' element={<ErrorBoundary><AboutUsPage /></ErrorBoundary>} />

          <Route path='openbanking/callback' element={<ErrorBoundary><PaymentCallbackPage /></ErrorBoundary>} />

          <Route path='easybanking/success' element={<ErrorBoundary><ConfirmationPage /></ErrorBoundary>} />
          <Route path='payment-failed' element={<ErrorBoundary><PaymentFailurePage /></ErrorBoundary>} />
          <Route path='settings' element={<ErrorBoundary><SettingsPage /></ErrorBoundary>} />

          <Route path='404' element={<ErrorBoundary><NotFoundPage /></ErrorBoundary>} />
          <Route path='error' element={<ErrorBoundary><ErrorPage /></ErrorBoundary>} />

          <Route path='*' element={<ErrorBoundary><NotFoundPage /></ErrorBoundary>} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
